import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import TopBusinessQuotesWrapper from "@components/layouts/topBusinessQuotesWrapper";

export default function TopBusinessQuotesHome(): ReactElement {
    return (
        <TopBusinessQuotesWrapper>
            <PrivacyPolicy domain="TopBusinessQuotes.com" category="B2B" />
        </TopBusinessQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
